"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoProjectIdFoundInApp"));
const GeoFire_1 = __importDefault(require("../utils/GeoFire"));
const callableGeoFireQueryBuilder = async ({ functionId, callbacks, executeProcesses, processor, entryVars: { latitude, longitude, radius, groupName, }, }) => {
    const onError = (errorData) => {
        executeProcesses(functionId, callbacks.errorProcess, errorData);
    };
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        onError((0, getErrorMessageNoProjectIdFoundInApp_1.default)('geoFireQuery'));
        return;
    }
    const appGeofireDbRef = groupName
        ? processor.root.firebase.database().ref(`projects/${projectId}/geoFireGroups/${groupName}`)
        : processor.root.firebase.database().ref(`projects/${projectId}/geoFire`);
    const geoFire = new GeoFire_1.default(appGeofireDbRef);
    const numLatitude = Number(latitude);
    const numLongitude = Number(longitude);
    const numRadius = Number(radius);
    const areNumbers = !Number.isNaN(numLatitude)
        && !Number.isNaN(numLongitude)
        && !Number.isNaN(numRadius);
    if (areNumbers) {
        const geoQuery = geoFire.query({
            center: [numLatitude, numLongitude],
            radius: numRadius,
        });
        const keyLocationEntered = geoQuery.on('key_entered', (key, location, distanceFromCenter, data) => {
            executeProcesses(functionId, callbacks.keyLocationEntered, {
                keyLocation: key,
                latitude: location[0],
                longitude: location[1],
                region: {
                    latitude: location[0],
                    longitude: location[1],
                },
                data,
            });
        });
        const keyLocationExited = geoQuery.on('key_exited', (key) => {
            executeProcesses(functionId, callbacks.keyLocationExited, {
                keyLocation: key,
            });
        });
        const keyLocationMoved = geoQuery.on('key_moved', (key, location, distanceFromCenter, data) => {
            executeProcesses(functionId, callbacks.keyLocationMoved, {
                keyLocation: key,
                latitude: location[0],
                longitude: location[1],
                region: {
                    latitude: location[0],
                    longitude: location[1],
                },
                data,
            });
        });
        processor.root.registerGeoQuery([keyLocationEntered, keyLocationExited, keyLocationMoved]);
        return;
    }
    onError('All fields are required and must be numbers.');
};
exports.default = callableGeoFireQueryBuilder;
